import { z } from 'zod';

export type TBackground = z.infer<typeof imageSchema>;

const imageSchema = z
  .object({
    data: z
      .object({
        attributes: z.object({
          url: z.string(),
          alternativeText: z.string().optional().nullable(),
        }),
      })
      .nullish(),
  })
  .optional();

const LogoSchema = z
  .object({
    image: z
      .object({
        data: z
          .object({
            attributes: z.object({
              url: z.string(),
              alternativeText: z.string().optional().nullable(),
            }),
          })
          .nullable(),
      })
      .nullable()
      .optional(),
    variant: z.enum(['Small', 'Large']),
    position: z.enum(['Left', 'Middle', 'Right']),
  })
  .nullable()
  .optional();

export type TLogo = z.infer<typeof LogoSchema>;

export { imageSchema, LogoSchema };
